import React, { Component } from 'react';


import imgjson from "./assets/json.png"
import imgrtf from "./assets/rtf.png"
import imgtxt from "./assets/txt.png"
import imgstl from "./assets/stl.png"
import imgsrt from "./assets/srt.png"
import imgttml from "./assets/ttml.png"
import imgdocx from "./assets/docx.png"
import Icon from '../../../../components/bases/icone/icon';
import { GlobalContext } from '../../../../utils/globalprovider';

import { AppExport_ExportType } from '../../../../utils/software';



import "./exportsstyles.css"

class ExportType extends React.Component
{

    static contextType = GlobalContext;

constructor (props)
{
    super(props);
    this.state =
    {
        value: "",
        
    }

    this.currentFormat = AppExport_ExportType.notdefined;
    this.exportFormats = 
  
    
          [
              {
                  type: AppExport_ExportType.video,
                  formats:
                  [
 
                  ],
              },
  
              {
                type: AppExport_ExportType.transcription,
                formats:
                [
                    
                    {type:"txt1",ext:"txt",img:imgtxt,titlefr:"Export Format Texte Simple",titleen:"Simple Text Format", subtitlefr:"Format texte simple sans time code",subtitleen:"Simple text format without timecode"},
                    {type:"json0",ext:"json",img:imgjson,titlefr:"Export Format JSON DAIA",titleen:"DAIA JSON Format", subtitlefr:"Export Format JSON DAIA.",subtitleen:"DAIA Json Format"},
                    {type:"json1",ext:"json",img:imgjson,titlefr:"Export Format JSON O.T.T.O",titleen:"O.T.T.O. JSON Format", subtitlefr:"Format Json interne à O.T.T.O.",subtitleen:"Internal O.T.T.O. Json Format"},
                    {type:"json2",ext:"json",img:imgjson,titlefr:"Export Type Phrases Format JSON",titleen:"Export Phrase Types in JSON Format", subtitlefr:"Export Type Phrases avec TC Format JSON.",subtitleen:"Export Phrase Types with TC in JSON Format"},
                    {type:"docx1",ext:"docx",img:imgdocx,titlefr:"Export Continuité dialoguée (docx)",titleen:"Continuity Dialog Export (docx)", subtitlefr:"Export continuité dialoguée avec page de garde vide.",subtitleen:"Export dialog continuity with blank cover page."},
                    {type:"txt2",ext:"txt",img:imgtxt,titlefr:"Export Texte Unicode Tabulé (Mosaic)",titleen:"Export Tab-Delimited Unicode Text (Mosaic)", subtitlefr:"Format Texte avec TC Début, TC Fin, Personnage et textes",subtitleen:"Text format with Start TC, End TC, Character, and text."},
                ],
              },

              {
                type: AppExport_ExportType.subtitle,
                formats:
                [
                    {type:"stl0",ext:"stl",img:imgstl,titlefr:"Export Format STL FRANCE TELEVISION",titleen:"FRANCE TV STL Format", subtitlefr:"Format STL ouvert ou fermé France TV",subtitleen:"France TV STL format opened or closed"},
                    {type:"stl1",ext:"stl",img:imgstl,titlefr:"Export Format STL",titleen:"STL Format", subtitlefr:"Format STL ouvert ou fermé",subtitleen:"STL format opened or closed"},
                    {type:"ttml1",ext:"ttml",img:imgttml,titlefr:"Export Format TTML",titleen:"TTML Format", subtitlefr:"Format TTML ouvert ou fermé",subtitleen:"TTML format opened or closed"},
                    {type:"json1",type:"json1",ext:"json",img:imgjson,titlefr:"Export Format JSON O.T.T.O",titleen:"O.T.T.O. JSON Format", subtitlefr:"Format Json interne à O.T.T.O.",subtitleen:"Internal O.T.T.O. Json Format"},
                    {type:"txt1",ext:"txt",img:imgtxt,titlefr:"Export Format Texte Simple",titleen:"Simple Text Format", subtitlefr:"Format texte simple avec ou sans time code",subtitleen:"Simple text format with or without timecode"},
                    {type:"srt1",ext:"srt",img:imgsrt,titlefr:"Export Format SRT Simple",titleen:"Simple SRT Format", subtitlefr:"Format SRT simple sans attributs",subtitleen:"Simple SRT format without attributs"},
                    {type:"rtf1",ext:"rtf",img:imgrtf,titlefr:"Export Format RTF Simple",titleen:"Simple RTF Format", subtitlefr:"Format RTF simple sans time code",subtitleen:"Simple RTF format without timecode"},
                ],
              },

            ]
    
  
        this.onclick = this.onclick.bind(this)

}



componentDidMount()
{
    // on commence par lire l'asset
    if (this.props.onclick) this.props.onclick(this.currentFormat, this.state.value, this.getLib(this.currentFormat, this.state.value))

}                                                                                    
componentDidUpdate()
{

    if (this.props.onclick) this.props.onclick(this.currentFormat, this.state.value, this.getLib(this.currentFormat, this.state.value))
}


getLib (format, value)
{
    var ind = this.getIndexByFormat(format);
    if (ind !== -1)
    {
        const listeformat = this.exportFormats[ind].formats;
        for (var i=0; i< listeformat.length; i++)
        {
            if (listeformat[i].type === value)
                return this.context.language=="fr"?listeformat[i].titlefr:listeformat[i].titleen
        }
        return "?!";
    }
    else
        return "?";

}

onclick(ind)
{
    
    var listeformat=[];
    var indx = this.getIndexByFormat(this.props.type);
    //indx = this.getIndexByFormat(AppExport_ExportType.subtitle)
    if (indx !== -1)
    {
        listeformat = this.exportFormats[indx].formats;
        this.setState({value: listeformat[ind].type});
        
    }

}
getIndexByFormat (format)
{
    for (var i=0; i < this.exportFormats.length; i++)
    {
        if (this.exportFormats[i].type === format) return i;
    }
    return -1;
}

render()
{

    var liste = (<></>);
    var listeformat=[];
    if (this.props.type !== AppExport_ExportType.notdefined) 
    {

        var ind = this.getIndexByFormat(this.props.type);
        if (ind !== -1)
        {
            listeformat = this.exportFormats[ind].formats;
        }

    
        if (this.currentFormat !== this.props.type)
        {
            this.currentFormat = this.props.type;
            
            if  (listeformat.length !==0)
            {
                this.setState({value: listeformat[0].type});
                return; 
            }
        }
    }

    liste = [];

    for (var i=0; i< listeformat.length; i++)
    {
        var title = this.context.language=="fr"?listeformat[i].titlefr:listeformat[i].titleen
        var subtitle = this.context.language=="fr"?listeformat[i].subtitlefr:listeformat[i].subtitleen
        var cl = "exportformatnonselected";
        if (this.state.value === listeformat[i].type)
            var cl = "exportformatselected";
        const u=i;
        liste.push(
            <div className={cl} onClick= {(e) => this.onclick(u)  } >
                <div className='exportformatline1'>
                <Icon image={listeformat[i].img} height="32" width="32"/>
                <div>
                &nbsp;&nbsp;{title} <br/>
                &nbsp;&nbsp;<span style={{fontSize:"10px"}}>{subtitle}</span>
                <span style={{fontSize:"10px", color:"gray"}}> &nbsp;&nbsp;&nbsp;Extension&nbsp;:&nbsp;</span>
                <span style={{fontSize:"10px"}}>{listeformat[i].ext}</span>
                </div>
                </div>
            </div>
        )
    }

    return (<div className="exportformatliste">

                {liste}
            </div>
        )


}

}
export default ExportType;

